import _jsx from '@babel/runtime/helpers/jsx';
import React, { forwardRef, isValidElement } from 'react';
import classNames from 'classnames';
import warning from '@andes/common/build/utils/warning';
import { useId } from '@andes/context';
import _extends from '@babel/runtime/helpers/extends';
const WARNING_HREF_DISABLED = "<Breadcrumb> requires each element within the levels property to contain an href or\ndisabled attribute. Please add one or the other to each item.";
var _svg;
const Chevron = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    "aria-hidden": true
  }, void 0, _svg || (_svg = /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "6",
    height: "8"
  }, void 0, /*#__PURE__*/_jsx("path", {
    fill: "none",
    stroke: "#666",
    d: "M1 0l4 4-4 4"
  }))));
};
var Chevron$1 = Chevron;
var _Chevron;
const namespace$1 = 'andes-breadcrumb';
const BreadcrumbLevel = _ref => {
  let {
    title,
    id,
    text,
    href,
    onClick,
    disabled = false,
    isCurrentPage = false
  } = _ref;
  const componentId = useId(id);
  const commonProps = {
    title,
    'aria-current': isCurrentPage ? 'page' : undefined
  };
  const getOnClickLevel = event => {
    if (typeof onClick === 'function') onClick(event);
  };
  return /*#__PURE__*/_jsx("li", {
    className: "".concat(namespace$1, "__item")
  }, id || "".concat(componentId), disabled ? /*#__PURE__*/React.createElement("span", _extends({
    className: "".concat(namespace$1, "__label")
  }, commonProps), text) : /*#__PURE__*/React.createElement("a", _extends({
    className: "".concat(namespace$1, "__link"),
    onClick: getOnClickLevel,
    href: href
  }, commonProps), text), !isCurrentPage ? _Chevron || (_Chevron = /*#__PURE__*/_jsx(Chevron$1, {
    className: "".concat(namespace$1, "__chevron")
  })) : null);
};
var BreadcrumbLevel$1 = BreadcrumbLevel;
const namespace = 'andes-breadcrumb';
const Breadcrumb = /*#__PURE__*/function () {
  const Breadcrumb = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      'aria-label': _willdeprecate$ariaLabel,
      children,
      className,
      id,
      levels: _willdeprecate$levels,
      srLabel
    } = _ref;
    const componentId = useId(id);
    if (!children && (!_willdeprecate$levels || _willdeprecate$levels.length === 0)) return null;
    if (_willdeprecate$levels !== null && _willdeprecate$levels !== void 0 && _willdeprecate$levels.length) {
      warning(_willdeprecate$levels.every(elem => elem.disabled || elem.href), WARNING_HREF_DISABLED);
    }
    const classes = classNames(namespace, className);
    const renderLevels = () => {
      if (!_willdeprecate$levels) return;
      return _willdeprecate$levels.map((_ref2, index) => {
        let {
          href,
          id: levelId,
          disabled,
          onClick,
          text,
          title
        } = _ref2;
        const isCurrentPage = index === _willdeprecate$levels.length - 1;
        return /*#__PURE__*/_jsx(BreadcrumbLevel$1, {
          id: levelId || "".concat(componentId, "-level-").concat(index),
          href: href,
          disabled: disabled,
          onClick: onClick,
          text: text,
          title: title,
          isCurrentPage: isCurrentPage
        }, "".concat(componentId, "-level-").concat(index));
      });
    };
    const renderChildren = () => {
      if (!children) return;
      return React.Children.map(children, (child, index) => {
        const hasValidChild = child && /*#__PURE__*/isValidElement(child);
        if (!hasValidChild) {
          return null;
        }
        const isCurrentPage = Array.isArray(children) ? index === children.length - 1 : true;
        return /*#__PURE__*/React.cloneElement(child, {
          isCurrentPage
        });
      });
    };
    return /*#__PURE__*/React.createElement("nav", {
      "aria-label": srLabel || _willdeprecate$ariaLabel,
      ref: ref,
      id: componentId
    }, /*#__PURE__*/_jsx("ol", {
      className: classes
    }, void 0, children ? renderChildren() : renderLevels()));
  });
  Breadcrumb.displayName = 'Breadcrumb';
  return Breadcrumb;
}();
var Breadcrumb$1 = Breadcrumb;
export { Breadcrumb$1 as Breadcrumb, BreadcrumbLevel$1 as BreadcrumbLevel, Breadcrumb$1 as default };
